/**
 * Asynchronously loads the component
 */

import { lazyLoad } from 'utils/loadable';

export const SupportDetails = lazyLoad(
  () => import('./index'),
  module => module.SupportDetails,
);
